import { CypressHistorySupport } from "cypress-react-router"
import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter, HashRouter } from "react-router-dom"
import App from "./App"
import "./index.css"
import { AnimationContextProvider } from "./Contexts/AnimationContext"
import { Provider } from "react-redux"
import { store } from "./store/store"
import NativeBackHandler from "./Components/NativeBackHandler"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <AnimationContextProvider>
      <HashRouter>
        {/* Above App on purpose: App returns an asset-loading screen
            before anything else, and a back press on that splash still
            has to background the app rather than kill it. */}
        <NativeBackHandler />
        <App />
      </HashRouter>
    </AnimationContextProvider>
  </Provider>
)
